import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=7c8abf7f&scoped=true&"
import script from "./Facebook.vue?vue&type=script&lang=js&"
export * from "./Facebook.vue?vue&type=script&lang=js&"
import style0 from "./Facebook.scss?vue&type=style&index=0&id=7c8abf7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8abf7f",
  null
  
)

export default component.exports